/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmp_Cta_SecondaryInputs */

const en_cmp_cta_secondary = /** @type {(inputs: Cmp_Cta_SecondaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See the format hub`)
};

const id_cmp_cta_secondary = /** @type {(inputs: Cmp_Cta_SecondaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat pusat format`)
};

/**
* | output |
* | --- |
* | "See the format hub" |
*
* @param {Cmp_Cta_SecondaryInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cmp_cta_secondary = /** @type {((inputs?: Cmp_Cta_SecondaryInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmp_Cta_SecondaryInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cmp_cta_secondary(inputs)
	return en_cmp_cta_secondary(inputs)
});